<template>
  <div class="wrap" v-if="showWrap" :class="showContent ? 'fadein' : 'fadeout'">{{ text }}</div>
</template>

<script>
export default {
  name: "toast"
}
</script>

<style scoped>
  .wrap{
    min-width: 270px;
    position: fixed;
    left: 50%;
    top:50%;
    background: rgba(3, 104, 193, 0.8);
    padding: 22px;
    border-radius: 15px;
    transform: translate(-50%,-50%);
    color:#fff;
    font-size: 20px;
    text-align: center;
    z-index: 999999999 !important;
  }
  .fadein {
    animation: animate_in 0.25s;
  }
  .fadeout {
    animation: animate_out 0.25s;
    opacity: 0;
  }
  @keyframes animate_in {
    0% {
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
  @keyframes animate_out {
    0% {
      opacity: 1;
    }
    100%{
      opacity: 0;
    }
  }
</style>
